<template>
    <div>
        <a-button type="link" block @click="() => (openModal = true)">
            Login to download template
        </a-button>
        <a-modal
            :visible="openModal"
            title="Login to continue"
            centered
            :closable="false"
            zIndex="999999999999999999 !important"
        >
            <template #footer>
                <a-button key="back" @click="handleCancel">Cancel</a-button>
                <a-button
                    key="submit"
                    type="primary"
                    :loading="submitting"
                    @click="login"
                    >Login</a-button
                >
            </template>
            <div class="form-group">
                <label for="email">Email Address</label>
                <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': error && error.email }"
                    v-model="form.email"
                    @change="() => (error.email = '')"
                />
                <div class="invalid-feedback" v-if="error && error.email">
                    {{ error.email[0] }}
                </div>
            </div>
            <div class="form-group">
                <label for="email">Password</label>
                <input
                    type="password"
                    class="form-control"
                    :class="{ 'is-invalid': error && error.password }"
                    v-model="form.password"
                    @change="() => (error.password = '')"
                />
                <div class="invalid-feedback" v-if="error && error.password">
                    {{ error.password[0] }}
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { WEBCALL } from "../api";
export default {
    data() {
        return {
            form: {
                email: "",
                password: "",
            },
            submitting: false,
            error: {},
            openModal: false,
        };
    },
    methods: {
        async login() {
            this.submitting = true;
            this.error = {};
            try {
                await WEBCALL.post("/login", this.form);
                window.location.reload();
            } catch (error) {
                if (error && error?.response && error?.response?.data?.errors) {
                    this.error = error?.response?.data?.errors;
                } else {
                    this.$notification.error({
                        message: "Failed to login",
                        description: "Try to login by visiting to login page",
                    });
                }
            }
            this.submitting = false;
        },
        resetForm() {
            this.form = {
                email: "",
                password: "",
            };
        },
        handleCancel() {
            this.resetForm();
            this.openModal = false;
        },
    },
};
</script>

<style scoped>
.form-control {
    border: 1px solid #d9d9d9;
}
.is-invalid {
    border: 1px solid #dc3545 !important;
}
</style>
